import ForgotPasswordPage from './ForgotPasswordPage'
import {fullPageLayoutConfig} from '../layout.helper'

export const ForgotPasswordPageConfig = {
  settings: {
    layout: fullPageLayoutConfig,
  },
  routes: [
    {
      path: '/forgot-password',
      component: ForgotPasswordPage,
    },
  ],
}



// WEBPACK FOOTER //
// ./src/main/content/login/ForgotPasswordPageConfig.js